import {
  type OrchestratedOfferingListingDetails,
  type OrchestratedAuctionListingDetails,
} from '@b-stock/fe-core/bstock-next/queries'
import { FormattedMessage } from '@b-stock/fe-core/bstock-react'

import {
  Card,
  CardHeader,
  CardTitle,
} from '@/buyer-portal/components/layouts/CardLayout/card/ui'

import { MakeAnOfferContent } from './MakeAnOfferContent'
import { useMakeAnOfferModel } from './useMakeAnOfferModel'

export const MakeAnOfferCard = ({
  listing,
}: {
  listing:
    | OrchestratedOfferingListingDetails
    | OrchestratedAuctionListingDetails
}) => {
  const model = useMakeAnOfferModel(listing)

  if (!model) return null

  return (
    <Card>
      <CardHeader>
        <CardTitle>
          <FormattedMessage id="Listing.sections.makeAnOffer.rowHeader" />
        </CardTitle>
      </CardHeader>
      <MakeAnOfferContent model={model} />
    </Card>
  )
}
